/**
 * OPM "Volatility source" dropdown options (Specify + each GPC approach).
 *
 * Shared between the initial SpreadsheetConfig and ValuationApproaches.updateMainSpreadsheets, which
 * calls allocationSpreadsheet.reset({ rowConfig }) with a fresh customRowConfig. That reset path
 * previously omitted volatilitySourceOptions, so the select had no GPC entries after cap-table
 * changes—the stored volatility_source id could not match any option and the field looked cleared.
 */
import { SPECIFY_VOLATILITY } from 'common/constants/allocations';
import { ValuationsApproach } from 'common/types/valuation';
import { VolatilitySourceListProps } from 'pages/ValuationsAllocation/allocation/EquityAllocation/components/VolatilitySource/VolatilitySource.props';
import { VALUATIONS_PUBLIC_COMPANIES_APPROACH } from 'pages/ValuationsAllocation/common/constants/valuations';

/** Build the same option list as the equity-allocation sheet expects for VolatilitySource / SelectValueViewer. */
export const getEquityAllocationVolatilitySourceOptions = (
  approaches?: ValuationsApproach[]
): VolatilitySourceListProps[] => {
  const gpcApproaches = (approaches ?? []).filter(
    approach => approach.approach_type === VALUATIONS_PUBLIC_COMPANIES_APPROACH
  );

  return [
    {
      label: SPECIFY_VOLATILITY,
      value: null,
    },
    ...gpcApproaches.map(approach => ({
      label: approach?.name ?? '',
      value: approach.valuations_approach_gpc?.id?.toString() ?? approach.panelId ?? '',
    })),
  ];
};
